module.exports = __webpack_public_path__ + "img/fcrVolume.ca9899d1.png";